import TrendsList from "./TrendsList";

const { register } = require("@lpm/pug-components/dist/register");

register("TrendsList/TrendsList", TrendsList);
